import { Component, OnInit } from '@angular/core';
import { IconBaseComponent } from '../icon-base/icon-base.component';

@Component({
  selector: 'app-icon-apt',
  templateUrl: './icon-apt.component.html',
  styleUrls: ['./icon-apt.component.scss']
})
export class IconAptComponent extends IconBaseComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
